import TerminalWrapper from './TerminalWrapper'

export default TerminalWrapper
